import PropTypes from "prop-types";
import { THEME } from "./constants";
export const ReportDialogPropTypes = {
  theme: PropTypes.oneOf(Object.values(THEME)),
  eventId: PropTypes.string.isRequired,
  dsn: PropTypes.shape({
    projectId: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string
  }),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtitle2: PropTypes.string,
  labelName: PropTypes.string,
  labelEmail: PropTypes.string,
  labelComments: PropTypes.string,
  labelKeepMeUpdated: PropTypes.string,
  labelClose: PropTypes.string,
  labelSubmit: PropTypes.string,
  errorGeneric: PropTypes.string,
  errorFormEntry: PropTypes.string,
  successMessage: PropTypes.string,

  /** Callback after reportDialog showed up */
  onLoad: PropTypes.func,

  /** Callback before close reportDialog */
  onClose: PropTypes.func
};
export const ReportDialogDefaultProps = {
  theme: THEME.LIGHT,
  title: "It looks like we’re having issues.",
  subtitle: "Our team has been notified.",
  subtitle2: "If you’d like to help, tell us what happened below.",
  labelName: "NAME",
  labelEmail: "EMAIL",
  labelComments: "WHAT HAPPENED?",
  labelKeepMeUpdated: "Do you want to be notified?",
  labelClose: "Close",
  labelSubmit: "Submit Crash Report",
  errorGeneric: "Sorry, we were unable to record your feedback",
  errorFormEntry: "Some fields were invalid. Please correct the errors and try again.",
  successMessage: "Thanks for your feedback"
};